import {useUpdateAuth} from "@/contexts/AuthProvider";
import {AxiosError, AxiosResponse} from "axios";
import {API_URL} from "@/utils/const/api";
import {URL} from "@/utils/const/url";

import {useToast} from "@/contexts/ToastProvider";

import {useRouter} from "@/navigation";
import {useState} from "react";
import {TRegister, TRegisterInput} from "@/types/api/Auth/Register";
import useAxiosClient from "@/lib/axios";
import {getRefId} from "@/utils/referral";
import {useCookies} from "react-cookie";
import {COOKIE_FIRST_TIME_REGISTERED, COOKIE_TOKEN_NAME} from "@/utils/const/cookie";

export const useRegister = () => {
    const [_, setCookie] = useCookies([COOKIE_TOKEN_NAME, COOKIE_FIRST_TIME_REGISTERED]);
    const [loading, setLoading] = useState<boolean>(false);
    const { setToken } = useUpdateAuth();
    const toast = useToast();
    const router = useRouter();
    const axiosClient = useAxiosClient();


    const submitRegister = async (data: TRegisterInput) => {
        setLoading(true);

        const ref_id = getRefId();

        const registerData: TRegister = {
            name: data.name,
            surname: data.surname,
            password: data.password,
            email: data.email,
            from_ref_id: ref_id
        }

        try {
            const resToken = await axiosClient.post<any, AxiosResponse<{ token: string }>, any>(
                API_URL.REGISTER,
                registerData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            setCookie(COOKIE_FIRST_TIME_REGISTERED, true, { path: "/" });
            setCookie(COOKIE_TOKEN_NAME, resToken.data.token, { path: "/" });
            setToken(resToken.data.token)
            window.location.href = URL.DASHBOARD;
        } catch (e) {

            if (e instanceof AxiosError) {
                toast.error(e.response?.data.error);
            }
            else toast.error('Nastala chyba, zkuste to prosím později');
        } finally {
            setLoading(false)
        }

    };
    return { submitRegister, loading };

}

export default useRegister;
